<template>
  <div class="homePage maxWidth">
    <!-- 轮播图 -->
    <div class="homePageBanner maxWidth">
      <el-carousel class="bannerBox" arrow="never">
        <el-carousel-item v-for="(item, index) in banners" :key="index">
          <img :src="baseUrl + item.pic" alt="" />
          <div class="bannerBtn">
            <span class="title">{{ item.edescription }}</span>
            <span class="name">{{ item.name }}</span>
            <span class="text">{{ item.description }}</span>
            <div class="bannerBtnBox">
              <button class="btn1" type="button" @click="clickParent">
                立即咨询
              </button>
              <button class="btn2" @click="toAboutUsClick">了解我们</button>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="toBottom" @click="toBottom">
        <span class="el-icon-bottom"></span>
      </div>
    </div>
    <!-- 我们的承诺 -->
    <div class="ourCommitment maxWidth">
      <div class="ourCommitment-top">
        <img src="../assets/bigTy.png" alt="" />
        <span class="title">{{ ourCommitmentItem.name }}</span
        ><span>{{ ourCommitmentItem.description }}</span>
      </div>
      <div class="ourCommitment-main">
        <div class="ourCommitment-mainB"></div>
        <div class="ourCommitmentList">
          <div
            class="ourCommitment-mainBox"
            v-for="(item, index) in ourCommitmentItem.lists"
            :key="index"
          >
            <img class="picNumber" :src="item.number_icon" alt="" />
            <div class="picBox">
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 四大产品方向 -->
    <div class="directionFour maxWidth">
      <div class="directionFour-banner">
        <div class="directionFour-bannerTop">
          <img src="../assets/bigTy1.png" alt="" />
          <span class="title">{{ productList.name }}</span
          ><span>{{ productList.description }}</span>
        </div>
        <div class="directionFour-bannerBottom">
          <div
            class="bannerBottomBox"
            @click="picClick(index)"
            v-for="(item, index) in productList.lists"
            :key="index"
          >
            <img :src="baseUrl + item.icon1" alt="" />
            <div :class="{ textBox: picShow == index }">
              <span :class="{ textActive: picShow == index }">{{
                item.name
              }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="" v-for="(item, index) in productList.lists" :key="index">
        <div class="directionFour-main" v-if="picShow == index">
          <div class="directionFour-mainLeft">
            <img :src="baseUrl + item.img" alt="" />
          </div>
          <div class="directionFour-main-right">
            <div class="directionFour-main-rightTop">
              <img :src="baseUrl + item.icon2" alt="" />
              <span>{{ item.name }}</span>
            </div>
            <p>
              {{ item.description }}
            </p>
            <div class="directionFour-main-rightItem">
              <div
                class="rightItem-box"
                v-for="(itemText, indexText) in item.list"
                :key="indexText"
              >
                <span></span>
                <span>{{ itemText }}</span>
              </div>
            </div>
            <div class="directionFour-main-rightBtn">
              <button @click="loocClick(item)">查看详情</button>
              <button type="button" @click="clickParent">立即咨询</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 行业解决方案 -->
    <div class="industrySolutions maxWidth">
      <div class="industrySolutions-top">
        <img src="../assets/bigTy.png" alt="" />
        <span class="title">{{ solutionList.name }}</span>
      </div>
      <div class="industrySolutions-nav">
        <div class="industrySolutions-navList">
          <span
            v-for="(item, index) in solutionList.lists"
            :key="index"
            :class="{ navText: navShow == index }"
            @click="navClick(index)"
            >{{ item.name }}</span
          >
        </div>
      </div>
      <div class="" v-for="(item, index) in solutionList.lists" :key="index">
        <div class="industrySolutions-content" v-if="navShow == index">
          <div class="industrySolutions-contentLeft">
            <img :src="item.img" alt="" />
          </div>
          <div class="industrySolutions-contentRight">
            <div class="contentRight-top">
              <span>{{ item.name }}</span>
              <p>
                {{ item.description }}
              </p>
            </div>
            <div class="contentRight-bottom">
              <div class="contentRight-bottomTitle">
                <span>具体方案:</span>
              </div>
              <div class="contentRight-bottomItem">
                <div class="contentRight-bottomL">
                  <div
                    class="contentRight-bottomLBox"
                    v-for="(itemText, indexText) in item.list"
                    :key="indexText"
                  >
                    <span></span>
                    <span>{{ itemText }}</span>
                  </div>
                </div>
                <button type="button" @click="clickParent">立即咨询</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- //客户方案 -->
    <div class="customerCase maxWidth">
      <div class="customerCase-top">
        <div class="topTitleBox">
          <img src="../assets/bigTy.png" alt="" />
          <span class="customerCase-topTitle">{{ customerCaseList.name }}</span>
        </div>
        <span>{{ customerCaseList.description }}</span>
        <div class="customerCase-topBtn">
          <button @click="lookAll">查看全部</button>
          <button type="button" @click="clickParent">立即咨询</button>
        </div>
      </div>
      <div class="customerCase-banner">
        <button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--left"
          @click="prevClick"
        >
          <i class="el-icon-arrow-left"></i></button
        ><button
          type="button"
          class="el-carousel__arrow el-carousel__arrow--right"
          @click="nextClick"
        >
          <i class="el-icon-arrow-right"></i>
        </button>
        <el-carousel
          arrow="never"
          :interval="4000"
          :initial-index="swiperIndex"
          type="card"
          height="445px"
          indicator-position="none"
          class="customerCase-bannerList"
          ref="swiper"
          @change="swiperChange"
        >
          <el-carousel-item
            v-for="(item, index) in customerCaseList.lists"
            :key="index"
          >
            <img :src="item.bg" alt="" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div
        class="customerCase-bottom"
        v-for="(item, index) in customerCaseList.lists"
        :key="index"
      >
        <span v-if="index == swiperIndex">{{ item.title }}</span>
        <p v-if="index == swiperIndex">
          {{ item.description }}
        </p>
        <button v-if="index == swiperIndex" @click="lookXQ(item)">
          查看详情
        </button>
      </div>
    </div>
    <!-- //资讯动态 -->
    <div class="InformationDynamics maxWidth">
      <div class="InformationDynamics-top">
        <img src="../assets/bigTy.png" alt="" />
        <span class="InformationDynamics-topTitle">{{
          InformationList.name
        }}</span>
        <span>{{ InformationList.description }}</span>
      </div>
      <div class="InformationDynamics-main">
        <div
          class=""
          v-for="(item, index) in InformationList.lists"
          :key="index"
        >
          <div
            class="InformationDynamics-mainLeft"
            v-if="index == 0"
            @click="lookZX(item)"
          >
            <img :src="baseUrl + item.bg" alt="" />
            <div class="InformationDynamics-mainLeftBottom">
              <span>{{ item.cid }}&nbsp;|&nbsp;{{ item.title }}</span>
            </div>
          </div>
        </div>

        <div class="InformationDynamics-mainRight">
          <div
            class="InformationDynamics-textBox"
            v-for="(item, index) in InformationList.lists"
            :key="index"
            @click="lookZX(item)"
          >
            <span>{{ item.cid }}&nbsp;|&nbsp;{{ item.title }}</span>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <!-- 开发流程 -->
    <div class="developmentProcess maxWidth">
      <div class="developmentProcess-top">
        <img src="../assets/bigTy.png" alt="" />
        <span class="developmentProcess-topTitle">{{ liuchengList.name }}</span>
        <span>{{ liuchengList.description }}</span>
      </div>
      <div class="developmentProcess-main">
        <div class="developmentProcess-mainTop">
          <div
            class="liuchengBox"
            v-for="(item, index) in liuchengList.lists"
            :key="index"
          >
            <div class="liuchengBox-number">
              <span>{{ index + 1 }}</span>
            </div>
            <div class="liuchengBox-item">
              <div class="liuchengBox-itemTop">
                <span>{{ item.name }}</span>
                <img src="../assets/jiantou.png" alt="" />
              </div>
              <p>{{ item.description }}</p>
              <span @click="clickParent">立即咨询 ></span>
            </div>
          </div>
        </div>
      </div>
      <div class="developmentProcess-bottom">
        <div class="developmentProcess-bottomTitle">
          <span>{{ lcItem.name }}</span>
          <div>{{ lcItem.description }}</div>
        </div>
        <div class="developmentProcess-bottomBox">
          <div
            class="developmentProcess-item"
            v-for="(item, index) in lcItem.lists"
            :key="index"
          >
            <div class="developmentProcess-itemTop">
              <img :src="item.icon" alt="" />
              <span>{{ item.name }}</span>
            </div>
            <p>{{ item.description }}</p>
          </div>
        </div>
      </div>
    </div>
    <ZXDialog ref="mychild" />
  </div>
</template>

<script>
import ZXDialog from "../components/ZXDialog.vue";
export default {
  name: "homePage",
  components: { ZXDialog },

  metaInfo() {
    //设置浏览器标签页标题
    return {
      meta: [
        {
          name: "description",
          content: this.description
        }
      ]
    };
  },
  data() {
    return {
      description: "",
      picShow: 0,
      navShow: 0,
      swiperIndex: 0,
      bannerList: {},
      banners: [],
      // 我们的承诺
      ourCommitmentItem: {},
      // 四大产品方向
      productList: {},
      // 行业解决方案
      solutionList: {},
      // 客户方案
      customerCaseList: {},
      casesList: {},
      //资讯动态
      InformationList: {},
      newsPic: "",
      newsTitle: "",
      newsCname: "",
      //流程
      liuchengList: {},
      lcItem: {}
    };
  },
  created() {
    this.getList();
    console.log(this.baseUrl);
  },
  methods: {
    getList() {
      this.$axios.get("index/common/index").then(res => {
        // console.log(res.data.data);
        if (res.status == 200) {
          this.description = res.data.data.description;
          this.bannerList = res.data.data["01"];
          this.banners = res.data.data["01"].banners;
          // console.log(this.banners);
          this.ourCommitmentItem = res.data.data["02"];
          this.productList = res.data.data["03"];
          this.solutionList = res.data.data["04"];
          this.customerCaseList = res.data.data["05"];
          this.InformationList = res.data.data["06"];
          this.liuchengList = res.data.data["07"];
          this.lcItem = res.data.data["08"];
        }
      });
    },
    clickParent() {
      this.$refs.mychild.parentHandleclick();
    },
    loocClick(item) {
      this.$router.push({
        name: item.url
      });
    },
    lookAll() {
      this.$router.push({
        name: "customerCase"
      });
    },
    toBottom() {
      // 滚动内容的坐标位置0,50000：
      window.scrollTo(0, 50000);
    },
    picClick(index) {
      this.picShow = index;
    },
    navClick(index) {
      this.navShow = index;
    },
    lookXQ(item) {
      this.$router.push({
        name: "caseDetails",
        query: { id: item.id }
      });
    },
    lookZX(item) {
      this.$router.push({
        name: "newsInformationDetails",
        query: { id: item.id }
      });
    },
    prevClick() {
      this.$refs.swiper.prev();
    },
    nextClick() {
      this.$refs.swiper.next();
    },
    swiperChange(index) {
      // console.log(index);
      this.swiperIndex = index;
    },
    toAboutUsClick() {
      this.$router.push({
        name: "aboutUs"
      });
    }
  }
};
</script>

<style scoped>
.maxWidth {
  max-width: 100%;
}
.homePage {
  /* overflow: hidden; */
  width: 1920px;
  margin: 0 auto;
}
.homePageBanner {
  width: 1920px;
  margin: 0 auto;
  position: relative;
  margin-bottom: 74px;
}
.toBottom {
  width: 36px;
  height: 36px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 3px 4px 0px rgba(253, 66, 66, 0.4);
  border-radius: 50%;
  position: absolute;
  left: 50%;
  bottom: 21px;
  margin-left: -18px;
  z-index: 999;
  text-align: center;
  cursor: pointer;
}
.toBottom span {
  font-size: 22px;
  color: #ffffff;
  line-height: 36px;
  font-weight: 800;
}
.bannerBox {
  height: 805px;
  position: relative;
}
.bannerBox img {
  display: block;
  width: 100%;
}
.bannerBox .el-carousel__item {
  height: 805px;
}
.bannerBox .el-carousel__indicators--horizontal {
  bottom: 92px;
}
.bannerBox >>> .el-carousel__indicators--horizontal {
  bottom: 92px;
}
.bannerBox >>> .el-carousel__button {
  width: 60px;
  height: 2px;
  background: #dd3a3a;
}
.bannerBtn {
  display: flex;
  flex-direction: column;
  position: absolute;
  bottom: 191px;
  right: 320px;
  text-align: end;
}
.bannerBtnBox {
  display: flex;
  justify-content: end;
}
.bannerBtn .bannerBtnBox button {
  width: 210px;
  height: 54px;
  outline: none;
  border: 0;
  border-radius: 6px 0px 6px 0px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 54px;
  cursor: pointer;
}
.bannerBtn .title {
  width: 793px;
  font-size: 68px;
  font-family: DIN BlackAlternate;
  font-weight: 400;
  color: #454647;
  display: block;
  margin-bottom: 48px;
}
.bannerBtn .name {
  font-size: 50px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  display: block;
  margin-bottom: 18px;
}
.bannerBtn .text {
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #595959;
  display: block;
  margin-bottom: 71px;
}
.bannerBtn .bannerBtnBox .btn1 {
  color: #ffffff;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  box-shadow: 0px 14px 10px 0px rgba(253, 66, 66, 0.2);
  margin-right: 20px;
}
.bannerBtn .bannerBtnBox .btn2 {
  width: 150px;
  height: 54px;
  background: rgba(255, 255, 255, 0.3);
  border: 1px solid #ffffff;
  border-radius: 6px 0px 6px 0px;
}
.ourCommitment {
  width: 1339px;
  margin: 0 auto;
  margin-bottom: 143px;
}
.ourCommitment-top {
  display: flex;
  flex-direction: column;
  position: relative;
  text-align: center;
  margin-bottom: 53px;
}
.ourCommitment-top img {
  display: block;
  width: 37px;
  height: 37px;
  position: absolute;
  top: -6px;
  left: 41%;
}
.ourCommitment-top .title {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
  margin-bottom: 20px;
}
.ourCommitment-top span:last-child {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
}
.ourCommitment-main {
  margin: 0 auto;
  display: flex;
}

.ourCommitment-mainB {
  margin: 0 auto;
  width: 1200px;
  height: 300px;
  background: #f6fafb;
  border: 1px solid #ffffff;
  border-radius: 150px 0px 150px 0px;
  position: absolute;
}
.ourCommitmentList {
  position: relative;
  top: 53px;
  right: 40px;
  z-index: 99;
  display: flex;
}
.ourCommitment-mainBox {
  width: 296px;
  height: 194px;
  background: #ffffff;
  box-shadow: 0px 16px 30px 0px rgba(89, 98, 107, 0.12);
  border-radius: 6px;
  margin-right: 32px;
  position: relative;
  padding-top: 18px;
}
.ourCommitment-mainBox .picNumber {
  position: absolute;
  top: 9px;
  right: 9px;
  display: block;
  width: 79px;
  height: 89px;
}
.ourCommitment-mainBox .picBox {
  display: flex;
  flex-direction: column;
  width: 129px;
  margin: 0 auto;
  text-align: center;
}
.ourCommitment-mainBox .picBox img {
  display: block;
  width: 129px;
  height: 110px;
  margin-bottom: 19px;
}
.ourCommitment-mainBox .picBox span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #192537;
  line-height: 32px;
}
.directionFour {
}
.directionFour-banner {
  height: 400px;
  background-image: url("~../assets/directionBanner.png");
  background-repeat: no-repeat;
  /* background-size: 100%; */
  position: relative;
}
.directionFour-bannerTop {
  text-align: center;
  display: flex;
  flex-direction: column;
  padding-top: 64px;
  position: relative;
}
.directionFour-bannerTop img {
  display: block;
  width: 37px;
  height: 37px;
  position: absolute;
  top: 58px;
  left: 43%;
  margin-left: -8px;
}
.directionFour-bannerTop .title {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 20px;
}
.directionFour-bannerTop span:last-child {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
}
.directionFour-bannerBottom {
  margin: 0 auto;
  width: 1236px;
  display: flex;
  margin-top: 93px;
}
.bannerBottomBox {
  width: 210px;
  display: flex;
  flex-direction: column;
  margin-right: 137px;
  text-align: center;
  cursor: pointer;
}
.bannerBottomBox img {
  margin: 0 auto;
  display: block;
  width: 75px;
  height: 76px;
  margin-bottom: 15px;
}
.bannerBottomBox > div {
  width: 210px;
}
.bannerBottomBox .textBox {
  width: 210px;
  height: 51px;
  background-color: #fff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  line-height: 54px;
}
.bannerBottomBox span {
  font-size: 18px;
  font-family: PingFang SC;
  /* font-weight: bold; */
  color: #ffffff;
  white-space: nowrap;
}
.bannerBottomBox .textActive {
  background: linear-gradient(0deg, #dc3939 0%, #ff4242 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
}
.directionFour-main {
  display: flex;
  width: 100%;
  background: #ffffff;
  box-shadow: 0px 16px 30px 0px rgba(89, 98, 107, 0.12);
  margin-bottom: 46px;
}
.directionFour-mainLeft,
.directionFour-main-right {
  width: 50%;
}
.directionFour-mainLeft img {
  display: block;
  width: 100%;
}
.directionFour-main-right {
  padding-top: 37px;
  padding-left: 30px;
}
.directionFour-main-rightTop {
  display: flex;
  margin-bottom: 28px;
}
.directionFour-main-rightTop img {
  display: block;
  width: 46px;
  height: 42px;
  margin-right: 14px;
}
.directionFour-main-rightTop span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.directionFour-main-right > p {
  width: 610px;
  height: 42px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  line-height: 26px;
  margin-bottom: 43px;
}
.directionFour-main-rightItem {
  display: flex;
  flex-wrap: wrap;
  width: 535px;
  padding-left: 10px;
  /* margin-bottom: 55px; */
}
.rightItem-box {
  display: flex;
  width: 132px;
  line-height: 21px;
  text-align: left;
  align-items: center;
  margin-bottom: 38px;
  margin-right: 50px;
}
.rightItem-box:nth-child(3n) {
  margin-right: 0;
}
.rightItem-box span:first-child {
  width: 6px;
  height: 6px;
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 0px 3px 0px 3px;
  margin-right: 11px;
}
.rightItem-box span:last-child {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #595959;
  white-space: nowrap;
}
.directionFour-main-rightBtn {
  display: flex;
}
.directionFour-main-rightBtn button {
  width: 100px;
  height: 34px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  cursor: pointer;
}
.directionFour-main-rightBtn button:first-child {
  background: linear-gradient(0deg, #dc3939, #ff4242);
  color: #ffffff;
  margin-right: 14px;
}
.directionFour-main-rightBtn button:last-child {
  background: rgba(201, 206, 210, 0.1);
  border: 1px solid #c9ced2;
  font-weight: 400;
  color: #595959;
}
.industrySolutions {
  padding-top: 42px;
}
.industrySolutions-top {
  text-align: center;
  position: relative;
  margin-bottom: 66px;
}
.industrySolutions-top img {
  display: block;
  width: 37px;
  height: 37px;
  position: absolute;
  top: -6px;
  left: 43.3%;
  margin-left: -8px;
}
.industrySolutions-top span {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
  margin-bottom: 20px;
}
.industrySolutions-nav {
  border-bottom: 1px solid #d6dbdd;
  margin-bottom: 42px;
}
.industrySolutions-navList {
  width: 750px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
}
.industrySolutions-navList span {
  /* margin-right: 100px; */
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  line-height: 50px;
  cursor: pointer;
  white-space: nowrap;
}
.industrySolutions-navList .navText {
  color: #df3a3a;
  border-bottom: 3px solid #df3a3a;
  padding-bottom: 15px;
}
.industrySolutions-navList span:last-child {
  margin-right: 0;
}
.industrySolutions-content {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  margin-bottom: 83px;
}
.industrySolutions-contentLeft {
  margin-right: 102px;
}
.industrySolutions-contentLeft img {
  display: block;
}
.industrySolutions-contentRight {
  padding-top: 35px;
}
.contentRight-top {
  margin-bottom: 70px;
}
.contentRight-top span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #00000c;
  line-height: 70px;
}
.contentRight-top p {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
}
.contentRight-bottomTitle {
  margin-bottom: 16px;
}
.contentRight-bottomTitle span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
}
.contentRight-bottomL {
  display: flex;
  flex-wrap: wrap;
}
.contentRight-bottomLBox {
  width: 175px;
  display: flex;
  align-items: center;
  margin-right: 40px;
  margin-bottom: 27px;
}
.contentRight-bottomLBox:nth-child(3) {
  margin-bottom: 0;
}
.contentRight-bottomLBox:nth-child(4) {
  margin-bottom: 0;
}
.contentRight-bottomLBox span:first-child {
  width: 6px;
  height: 6px;
  background: #c5d1da;
  border-radius: 0px 3px 0px 3px;
  margin-right: 11px;
}
.contentRight-bottomLBox span:last-child {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #192537;
  white-space: nowrap;
}
.contentRight-bottomItem {
  width: 610px;
  height: 98px;
  background: linear-gradient(-90deg, #ffffff, #f6fafb);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 30px;
}
.contentRight-bottomItem button {
  /* width: 100px;
  height: 34px; */
  background: linear-gradient(0deg, #dc3939, #ff4242);
  border-radius: 6px 0px 6px 0px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
  align-items: center;
  padding: 10px 22px;
  white-space: nowrap;
}
.customerCase {
  display: flex;
  flex-direction: column;
  height: 1000px;
  background-image: url("~../assets/customerCase-banner.png");
  background-repeat: no-repeat;
  position: relative;
  padding: 64px 0;
}
.customerCase-top {
  text-align: center;
  display: flex;
  flex-direction: column;
  margin-bottom: 54px;
}
.customerCase-top span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #ffffff;
  margin-bottom: 41px;
}
.topTitleBox {
  position: relative;
  margin-bottom: 24px;
}
.topTitleBox img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 44.6%;
  top: -7px;
}
.customerCase-banner {
  width: 1390px;
  margin: 0 auto;
}
.customerCase-bannerList >>> .el-carousel__mask {
  background-color: rgba(0, 0, 0, 1) !important;
}
.customerCase-bannerList >>> .el-carousel__item:nth-child(2n) {
  /* background-color: red; */
}

.customerCase-bannerList >>> .el-carousel__item:nth-child(2n + 1) {
  /* background-color: yellow; */
}
.customerCase-bannerList >>> .el-carousel__item {
  width: 696px;
  height: 445px;
  border: 2px solid #ffffff;
  box-shadow: 0px 26px 20px 0px rgba(0, 0, 0, 0.4);
  border-radius: 14px;
}
.customerCase-bannerList >>> .el-carousel__item img {
  display: block;
  width: 696px;
  height: 445px;
}
.customerCase-banner >>> .el-icon-arrow-left:before {
  display: block;
  content: " ";
  background-image: url("~../assets/jiantou-left.png");
  background-size: contain;
  width: 27px;
  height: 20px;
  background-repeat: no-repeat;
}
.customerCase-banner >>> .el-carousel__arrow--left {
  width: 48px;
  height: 48px;
  background: rgba(201, 206, 210, 0.1);

  border-radius: 0;
  left: 75px;
  top: 50%;
}
.customerCase-banner >>> .el-carousel__arrow--right {
  width: 48px;
  height: 48px;
  background: rgba(201, 206, 210, 0.1);

  border-radius: 0;
  top: 50%;
  right: 75px;
}
.customerCase-banner >>> .el-carousel__arrow {
  font-size: 30px;
}
.customerCase-banner >>> .el-icon-arrow-right:before {
  display: block;
  content: " ";
  background-image: url("~../assets/jiantou-right.png");
  background-size: contain;
  width: 27px;
  height: 20px;
  background-repeat: no-repeat;
}
.customerCase-bannerList .el-carousel__arrow {
  background: #c9ced2;
  align-items: center;
}
.customerCase-bannerList .el-carousel__arrow:hover {
  background: linear-gradient(0deg, #dc3939, #ff4242);
}
.customerCase-bannerList >>> .el-carousel__button {
  width: 100px;
  height: 3px;
  background: #df3a3a;
}

.customerCase-top .customerCase-topTitle {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
}
.customerCase-topBtn button {
  width: 162px;
  height: 44px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  cursor: pointer;
}
.customerCase-topBtn button:first-child {
  background: linear-gradient(0deg, #dc3939, #ff4242);
  margin-right: 18px;
}
.customerCase-topBtn button:last-child {
  background: rgba(201, 206, 210, 0.1);
}
.customerCase-banner {
  /* height: 445px; */
}
.customerCase-bottom {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 40px;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding-top: 35px;
}
.customerCase-bottom span {
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 21px;
}
.customerCase-bottom p {
  margin: 0 auto;
  width: 584px;
  font-size: 15px;
  font-family: PingFang SC;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 24px;
  line-height: 26px;
}
.customerCase-bottom button {
  margin: 0 auto;
  width: 120px;
  height: 40px;
  background: rgba(201, 206, 210, 0.1);
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  cursor: pointer;
}
.InformationDynamics {
  width: 1294px;
  margin: 0 auto;
  padding-top: 100px;
  margin-bottom: 103px;
}
.InformationDynamics-top {
  display: flex;
  position: relative;
  margin-bottom: 35px;
}
.InformationDynamics-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  top: -15px;
  left: -15px;
}
.InformationDynamics-top span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
  line-height: 36px;
}
.InformationDynamics-top .InformationDynamics-topTitle {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
  margin-right: 20px;
}
.InformationDynamics-main {
  display: flex;
  height: 389px;
}
.InformationDynamics-mainLeft {
  position: relative;
  margin-right: 29px;
  cursor: pointer;
}
.InformationDynamics-mainLeft > img {
  display: block;
  width: 612px;
  height: 389px;

  border-radius: 14px;
}
.InformationDynamics-mainLeftBottom {
  width: 100%;
  position: absolute;
  padding: 0 39px;
  left: 0;
  bottom: 0;
  height: 94px;
  background: linear-gradient(0deg, #000000, rgba(0, 0, 0, 0));
  border-radius: 0px 0px 14px 14px;
  /* text-align: center; */
}
.InformationDynamics-mainLeftBottom span {
  display: block;
  margin: 0 auto;
  width: 533px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #ffffff;
  line-height: 94px;
}
.InformationDynamics-mainRight {
  padding-top: 26px;
  height: 385px;
  overflow: hidden;
}
.InformationDynamics-textBox {
  margin-bottom: 45px;
  cursor: pointer;
}
.InformationDynamics-textBox span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
  line-height: 32px;
  white-space: nowrap;
}
.InformationDynamics-textBox p {
  display: block;
  width: 639px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #454647;
  line-height: 26px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.developmentProcess {
  position: relative;
  margin-bottom: 383px;
}
.developmentProcess-top {
  display: flex;
  flex-direction: column;
  text-align: center;
  position: relative;
  padding-bottom: 45px;
  border-bottom: 1px solid #d6dbdd;
}
.developmentProcess-top img {
  display: block;
  width: 36px;
  height: 36px;
  position: absolute;
  left: 45%;
  top: -7px;
}
.developmentProcess-top span {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #595959;
}
.developmentProcess-top .developmentProcess-topTitle {
  font-size: 42px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #192537;
  margin-bottom: 24px;
}
.developmentProcess-main {
  position: relative;
}
.developmentProcess-mainTop {
  width: 1280px;
  margin: 0 auto;
  display: flex;
  position: relative;
  top: -13px;
  z-index: 998;
}
.liuchengBox {
  margin-right: 20px;
}
.liuchengBox:last-child {
  margin-right: 0;
}
.liuchengBox .liuchengBox-number {
  width: 26px;
  height: 26px;
  background: #ffffff;
  border: 1px solid rgba(255, 66, 66, 0.3);
  box-shadow: 0px 0px 10px rgba(255, 66, 66, 0.3);
  border-radius: 50%;
  text-align: center;
  line-height: 24px;
  margin-bottom: 32px;
}
.liuchengBox .liuchengBox-number span {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ff4242;
}
.liuchengBox-item {
  width: 240px;
  /* height: 166px; */
  background: #ffffff;
  box-shadow: 0px 14px 10px 0px rgba(0, 0, 0, 0.16);
  padding: 29px 20px 21px;
}
.liuchengBox-item > p {
  width: 200px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #454647;
  margin-bottom: 20px;
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.liuchengBox-item > span {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #595959;
  line-height: 10px;

  background: linear-gradient(0deg, #dc3939 0%, #ff4242 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  cursor: pointer;
}
.liuchengBox-itemTop {
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}
.liucphengBox-itemTop span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #00000c;
}
.liuchengBox-itemTop img {
  display: block;
  width: 25px;
  height: 24px;
}
.developmentProcess-bottom {
  width: 100%;
  height: 490px;
  background-image: url("~../assets/LC-banner.png");
  background-repeat: no-repeat;
  position: absolute;
  top: 265px;
  left: 0;
}
.developmentProcess-bottomTitle {
  width: 540px;
  position: absolute;
  top: 200px;
  left: 50%;
  margin-left: -270px;
}
.developmentProcess-bottomTitle span {
  font-size: 28px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
  margin-bottom: 25px;
}
.developmentProcess-bottomTitle > div {
  margin: 0 auto;
  margin-top: 25px;
  width: 260px;
  height: 34px;
  background: rgba(255, 255, 255, 0);
  border: 1px solid #ff8989;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffdce5;
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.developmentProcess-bottomBox {
  width: 1192px;
  margin: 0 auto;
  position: absolute;
  top: 396px;
  left: 50%;
  margin-left: -596px;
  display: flex;
  justify-content: space-between;
}
.developmentProcess-item > p {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffcdcd;
  line-height: 30px;
}
.developmentProcess-itemTop {
  display: flex;
}
.developmentProcess-itemTop span {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #ffffff;
}
.developmentProcess-itemTop img {
  display: block;
  width: 22px;
  margin-right: 8px;
}
</style>

<style></style>



// WEBPACK FOOTER //
// src/views/HomePage.vue